import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Tag, ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import portfolioData from '../data/portfolio.json';

const PortfolioDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const [project, setProject] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const foundProject = portfolioData.find(p => p.slug === slug);
    setProject(foundProject);
    window.scrollTo(0, 0);
  }, [slug]);

  const nextImage = () => {
    if (project && project.images) {
      setCurrentImageIndex((prev) => (prev + 1) % project.images.length);
    }
  };

  const prevImage = () => {
    if (project && project.images) {
      setCurrentImageIndex((prev) => (prev - 1 + project.images.length) % project.images.length);
    }
  };

  if (!project) {
    return (
      <div className="page-not-found">
        <div className="not-found-container">
          <h1>Projeto Não Encontrado</h1>
          <Link to="/portfolio" className="btn-primary">
            <ArrowLeft size={18} />
            Voltar ao Portfólio
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-portfolio-detail">
      <section className="portfolio-detail-hero">
        <div className="portfolio-detail-container">
          <Link to="/portfolio" className="back-link">
            <ArrowLeft size={18} />
            Voltar ao Portfólio
          </Link>
          
          <div className="portfolio-detail-tags">
            {project.tags.map((tag, index) => (
              <span key={index} className="portfolio-tag-large">
                <Tag size={14} />
                {tag}
              </span>
            ))}
          </div>
          
          <h1 className="portfolio-detail-title">{project.title}</h1>
          <p className="portfolio-detail-subtitle">{project.shortDescription}</p>
        </div>
      </section>

      {/* Carousel de Imagens */}
      <section className="portfolio-detail-images">
        <div className="portfolio-detail-container">
          <div className="portfolio-image-carousel">
            <img 
              src={project.images[currentImageIndex]} 
              alt={`${project.title} - Imagem ${currentImageIndex + 1}`} 
              className="portfolio-carousel-image"
            />
            
            {project.images.length > 1 && (
              <>
                <button 
                  className="carousel-btn carousel-btn-prev" 
                  onClick={prevImage}
                  aria-label="Imagem anterior"
                >
                  <ChevronLeft size={24} />
                </button>
                <button 
                  className="carousel-btn carousel-btn-next" 
                  onClick={nextImage}
                  aria-label="Próxima imagem"
                >
                  <ChevronRight size={24} />
                </button>
                
                <div className="carousel-indicators">
                  {project.images.map((_, index) => (
                    <button
                      key={index}
                      className={`carousel-indicator ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={() => setCurrentImageIndex(index)}
                      aria-label={`Ir para imagem ${index + 1}`}
                    />
                  ))}
                </div>

                <div className="carousel-counter">
                  {currentImageIndex + 1} / {project.images.length}
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Descrição Detalhada */}
      <section className="portfolio-detail-content">
        <div className="portfolio-detail-container">
          <div className="portfolio-detail-description">
            <h2 className="portfolio-section-title">Sobre este Dashboard</h2>
            <p className="portfolio-section-text">{project.longDescription}</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="portfolio-detail-cta-section">
        <div className="portfolio-detail-container">
          <div className="portfolio-cta-card-full">
            <h3 className="portfolio-cta-card-title">Interessado neste modelo?</h3>
            <p className="portfolio-cta-card-text">
              Entre em contato para adaptar este dashboard às necessidades específicas do seu negócio.
            </p>
            <a href="https://wa.me/5588996527079" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large">
              Solicitar Orçamento
              <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PortfolioDetail;
